// Mock data for DIGIROBOT website

import { IMAGES } from "../config/images";

const ROBOT_PROJECT_TITLES = {
  "attrape-blocs": "Attrape blocs",
  "attraper-des-objets": "Attraper des objets",
  "avancer-et-reculer": "Avancer et reculer",
  bulldozer: "Bulldozer",
  "canne-a-peche": "Canne à pêche",
  catapulte: "Catapulte",
  clavier: "Clavier",
  coffre: "Coffre",
  "conduire-sans-les-main": "Conduire sans les mains",
  "creature-robotique": "Créature robotique",
  "creature-robotique2": "Créature robotique II",
  crocobot: "Crocobot",
  "deplacer-des-objets": "Déplacer des objets",
  "detecteur-de-tremblement-de-terre": "Détecteur de séisme",
  "feux-de-signalisation": "Feux de signalisation",
  grenouille: "Grenouille",
  "jeu-de-bowling": "Jeu de bowling",
  "jeux-de-hockey": "Jeux de hockey",
  "lance-elastique": "Lance élastique",
  "lanceur-d-avion-6-9": "Lanceur d'avion 6-9 ans",
  "lanceur-d-avions-en-papier": "Lanceur d'avions en papier",
  manege: "Manège",
  "mille-pattes": "Mille-pattes",
  "mono-rail": "Mono rail",
  "monter-au-sommet": "Monter au sommet",
  "robot-artiste": "Robot artiste",
  "robot-batterie": "Robot batterie",
  "robot-chenille": "Robot chenille",
  "robot-chien-2": "Robot chien",
  "robot-de-combat": "Robot de combat",
  "robot-de-combat2": "Robot de combat II",
  "robot-danceur": "Robot danceur",
  "robot-elevateur": "Robot élévateur",
  "robot-footballeur": "Robot footballeur",
  "robot-golf": "Robot golf",
  "robot-moto": "Robot moto",
  "robot-sumo": "Robot sumo",
  "robot-sumo2": "Robot sumo II",
  "robot-arpenteur": "Robot arpenteur",
  "robot-arpenteur2": "Robot arpenteur II",
  scanner: "Scanner",
  "son-et-lumiere": "Son et lumière",
  "tire-sur-cible": "Tir sur cible",
  toupie: "Toupie",
  "tourner-a-gauche-et-a-droite": "Tourner à gauche et à droite",
  "voiture-6-9": "Voiture 6-9 ans",
  "voiture-telecommander": "Voiture télécommandée",
  "voiture-tout-terrain": "Voiture tout-terrain",
  "voiture-tout-terrain2": "Voiture tout-terrain II",
  rb1: "Voiture robotisée",
  rb2: "Kit Artec électronique",
  rb3: "Boîte intelligente",
  rb4: "Projet cursus débutant",
  rb5: "Robot bipède",
};

const pathToTitle = (path) => {
  const slug = path.split("/").pop().replace(/\.[^.]+$/, "");
  if (ROBOT_PROJECT_TITLES[slug]) return ROBOT_PROJECT_TITLES[slug];
  return slug
    .split("-")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const buildRobotProject = (id, path, category) => ({
  id,
  title: pathToTitle(path),
  image: path,
  category,
});

export const mockRobotProjects = [
  ...Object.entries(IMAGES.robots).map(([key, path]) =>
    buildRobotProject(`robot-${key}`, path, "Makeblock")
  ),
  ...Object.entries(IMAGES.offers).map(([key, path]) =>
    buildRobotProject(`offer-${key}`, path, "Artec / Algora")
  ),
];

export const mockFeaturedRobotProjects = [
  buildRobotProject("featured-rb1", IMAGES.offers.rb1, "Artec / Algora"),
  buildRobotProject("featured-rb5", IMAGES.offers.rb5, "Artec / Algora"),
  buildRobotProject("featured-chien", IMAGES.robots.robotChien2, "Makeblock"),
  buildRobotProject("featured-crocobot", IMAGES.robots.crocobot, "Makeblock"),
  buildRobotProject("featured-catapulte", IMAGES.robots.catapulte, "Makeblock"),
  buildRobotProject("featured-lanceur", IMAGES.robots.lanceurAvionsPapier, "Makeblock"),
  buildRobotProject("featured-sumo", IMAGES.robots.robotSumo, "Makeblock"),
  buildRobotProject("featured-vtt", IMAGES.robots.voitureToutTerrain, "Makeblock"),
  buildRobotProject("featured-combat", IMAGES.robots.robotCombat, "Makeblock"),
  buildRobotProject("featured-foot", IMAGES.robots.robotFootballeur, "Makeblock"),
  buildRobotProject("featured-creature", IMAGES.robots.creatureRobotique, "Makeblock"),
  buildRobotProject("featured-mille", IMAGES.robots.millePattes, "Makeblock"),
];

export const mockWorkshops = [
  {
    id: 1,
    title: "Atelier Découverte",
    ageRange: "6-16 ans",
    duration: "1h30",
    price: 0,
    isFree: true,
    description: "Première expérience OFFERTE de 90 minutes. Votre enfant monte son propre robot et découvre la programmation adaptée à son niveau.",
    image: IMAGES.workshops.decouverte,
    level: "Découverte",
    capacity: 8
  },
  {
    id: 2,
    title: "Atelier Défi Mercredi",
    ageRange: "6-16 ans",
    duration: "2h",
    price: 25,
    description: "Un jour, un thème ! 2h de jeu robotique avec défis et challenges. Chaque mercredi un nouveau défi passionnant.",
    image: IMAGES.workshops.defi,
    level: "Ludique",
    capacity: 10,
    themes: ["Construction", "Programmation", "Défis", "Compétition"]
  },
  {
    id: 3,
    title: "Atelier 1vs1 - Cours Particulier",
    ageRange: "6-16 ans",
    duration: "1h30",
    price: 60,
    description: "Cours particulier personnalisé avec un formateur dédié. Progression sur mesure selon les besoins et le niveau de l'enfant.",
    image: IMAGES.workshops.particulier,
    level: "Personnalisé",
    capacity: 1,
    benefits: ["Suivi individuel", "Programme sur mesure", "Progression rapide", "Horaires flexibles"]
  }
];

export const mockCurriculum = [
  {
    id: 1,
    title: "Cursus Débutant",
    ageRange: "6-8 ans",
    sessions: 30,
    duration: "1 an",
    price: 1150,
    pricePerMonth: 115,
    description: "Programme complet d'initiation à la robotique et à la programmation sur une année scolaire.",
    image: IMAGES.cursus.debutant,
    modules: [
      "Introduction à la robotique",
      "Construction de robots simples",
      "Premiers pas en programmation",
      "Résolution de problèmes logiques",
      "Projets créatifs"
    ],
    benefits: [
      "30 séances de 1h30",
      "Matériel fourni sur place",
      "Accès plateforme e-learning",
      "Certificat de fin de cursus",
      "Suivi personnalisé"
    ]
  },
  {
    id: 2,
    title: "Cursus Intermédiaire",
    ageRange: "9-12 ans",
    sessions: 30,
    duration: "1 an",
    price: 1150,
    pricePerMonth: 115,
    description: "Approfondissement des compétences en robotique et programmation avec des projets plus complexes.",
    image: IMAGES.cursus.intermediaire,
    modules: [
      "Programmation Scratch avancée",
      "Capteurs et actionneurs",
      "Intelligence artificielle basique",
      "Électronique de base",
      "Projets collaboratifs"
    ],
    benefits: [
      "30 séances de 2h",
      "Matériel fourni sur place",
      "Accès plateforme e-learning",
      "Participation concours",
      "Portfolio de projets"
    ]
  },
  {
    id: 3,
    title: "Cursus Avancé",
    ageRange: "13-16 ans",
    sessions: 30,
    duration: "1 an",
    price: 1150,
    pricePerMonth: 115,
    description: "Formation avancée pour maîtriser la programmation Python, Arduino et créer des robots autonomes.",
    image: IMAGES.cursus.avance,
    modules: [
      "Programmation Python",
      "Arduino et microcontrôleurs",
      "Intelligence artificielle",
      "Impression 3D",
      "Conception de robots autonomes"
    ],
    benefits: [
      "30 séances de 2h30",
      "Matériel fourni sur place",
      "Accès plateforme e-learning premium",
      "Préparation concours internationaux",
      "Mentorat individuel"
    ]
  }
];

export const mockCamps = [
  {
    id: 1,
    title: "Stage Arduino",
    ageRange: "Tous âges",
    description: "Apprenez à programmer avec Arduino et créez vos propres projets électroniques. Construction de circuits et programmation de microcontrôleurs.",
    image: IMAGES.stages.arduino,
    location: "Nice, Cannes, Monaco, Pégomas",
    priceOptions: [
      { duration: "10h", price: 240, label: "10h - 240€ TTC" },
      { duration: "20h", price: 320, label: "20h - 320€ TTC" }
    ],
    schedule: "Repas non inclus",
    included: [
      "Kit Arduino fourni",
      "Composants électroniques",
      "Projets à emporter",
      "Support pédagogique",
      "Certificat de participation"
    ]
  },
  {
    id: 2,
    title: "Stage Makeblock",
    ageRange: "Tous âges",
    description: "Robotique avec Makeblock. Programmation et construction de robots intelligents. Option achat robot inclus dans le stage.",
    image: IMAGES.stages.makeblock,
    location: "Nice, Cannes, Monaco, Pégomas",
    priceOptions: [
      { duration: "10h", price: 240, label: "10h - 240€ TTC (sans robot)" },
      { duration: "20h", price: 320, label: "20h - 320€ TTC (sans robot)" }
    ],
    robotOption: {
      available: true,
      robots: [
        { name: "mBot", price: 60, value: 89, label: "mBot (+60€ - valeur 89€)" },
        { name: "Codey Rocky", price: 70, value: 99, label: "Codey Rocky (+70€ - valeur 99€)" },
        { name: "mBot Ranger", price: 90, value: 139, label: "mBot Ranger (+90€ - valeur 139€)" }
      ],
      note: "Les promotions ne s'appliquent pas au tarif du robot"
    },
    schedule: "Repas non inclus",
    included: [
      "Robot Makeblock (si option choisie)",
      "Programmation par blocs",
      "Projets robotiques",
      "Support pédagogique",
      "Certificat de participation"
    ]
  },
  {
    id: 3,
    title: "Stage Drone",
    ageRange: "Tous âges",
    description: "Pilotage et programmation de drones. Découvrez les bases de l'aéronautique et de la programmation de vol.",
    image: IMAGES.stages.drone,
    location: "Nice, Cannes, Monaco, Pégomas",
    priceOptions: [
      { duration: "10h", price: 240, label: "10h - 240€ TTC" },
      { duration: "20h", price: 320, label: "20h - 320€ TTC" }
    ],
    schedule: "Repas non inclus",
    included: [
      "Drones fournis",
      "Pilotage et programmation",
      "Projets de vol",
      "Support pédagogique",
      "Certificat de participation"
    ]
  },
  {
    id: 4,
    title: "Stage Imprimante 3D",
    ageRange: "Tous âges",
    description: "Modélisation 3D et impression. Créez vos propres objets et découvrez les technologies de fabrication additive.",
    image: IMAGES.stages.imprimante3d,
    location: "Nice, Cannes, Monaco, Pégomas",
    priceOptions: [
      { duration: "10h", price: 240, label: "10h - 240€ TTC" },
      { duration: "20h", price: 320, label: "20h - 320€ TTC" }
    ],
    schedule: "Repas non inclus",
    included: [
      "Logiciel de modélisation 3D",
      "Impressions 3D incluses",
      "Créations à emporter",
      "Support pédagogique",
      "Certificat de participation"
    ]
  },
  {
    id: 5,
    title: "Stage Lego Robotique",
    ageRange: "Tous âges",
    description: "Construction et programmation avec Lego. Thème au choix : Architecture, Véhicules, Animaux, Ville, Espace.",
    image: IMAGES.stages.lego,
    location: "Nice, Cannes, Monaco, Pégomas",
    priceOptions: [
      { duration: "10h", price: 240, label: "10h - 240€ TTC" },
      { duration: "20h", price: 320, label: "20h - 320€ TTC" }
    ],
    themes: ["Architecture", "Véhicules", "Animaux", "Ville", "Espace"],
    schedule: "Repas non inclus",
    included: [
      "Kit Lego fourni",
      "Thème au choix",
      "Projets créatifs",
      "Support pédagogique",
      "Certificat de participation"
    ]
  },
  {
    id: 6,
    title: "Stage Fun & Learn DigiRobot",
    ageRange: "Tous âges",
    description: "Stage découverte multi-thèmes. Choisissez vos thèmes : Robotique découverte, Jeux vidéo, Électronique, Programmation Scratch.",
    image: IMAGES.stages.funLearn,
    location: "Nice, Cannes, Monaco, Pégomas",
    priceOptions: [
      { duration: "10h", price: 240, label: "10h - 240€ TTC" },
      { duration: "20h", price: 320, label: "20h - 320€ TTC" }
    ],
    themes: ["Robotique découverte", "Jeux vidéo", "Électronique", "Programmation Scratch", "Minecraft"],
    schedule: "Repas non inclus",
    included: [
      "Multi-activités",
      "Thèmes au choix",
      "Matériel fourni",
      "Support pédagogique",
      "Certificat de participation"
    ]
  }
];

export const mockRobots = [
  {
    id: 1,
    name: "Robot Débutant ALGORA",
    price: 149,
    ageRange: "6-8 ans",
    description: "Kit robotique parfait pour débuter. Facile à assembler et à programmer avec interface visuelle.",
    image: IMAGES.offers.rb1,
    features: [
      "200+ pièces",
      "Programmation visuelle",
      "8 modèles différents",
      "Guide pédagogique inclus"
    ],
    inStock: true,
    bonusMonths: 3
  },
  {
    id: 2,
    name: "Robot Intermédiaire ALGORA",
    price: 249,
    ageRange: "9-12 ans",
    description: "Kit robotique avec capteurs et moteurs pour créer des robots plus complexes.",
    image: IMAGES.offers.rb5,
    features: [
      "350+ pièces",
      "Capteurs tactiles et lumineux",
      "12 modèles avancés",
      "Programmation par blocs"
    ],
    inStock: true,
    bonusMonths: 6
  },
  {
    id: 3,
    name: "Kit Arduino Avancé",
    price: 179,
    ageRange: "13-16 ans",
    description: "Kit Arduino complet avec composants électroniques pour projets avancés.",
    image: IMAGES.offers.rb2,
    features: [
      "Carte Arduino Uno",
      "30+ composants électroniques",
      "Capteurs multiples",
      "Cours Python inclus"
    ],
    inStock: true,
    bonusMonths: 6
  },
  {
    id: 4,
    name: "Pack Complet Robotique Pro",
    price: 399,
    ageRange: "12-18 ans",
    description: "Pack complet pour les passionnés : robot + Arduino + impression 3D.",
    image: IMAGES.gallery.robotSeul,
    features: [
      "Robot ALGORA avancé",
      "Kit Arduino complet",
      "Accès impression 3D",
      "Mentorat 6 mois"
    ],
    inStock: true,
    bonusMonths: 12
  }
];

export const mockB2BOffers = [
  {
    id: 1,
    title: "Team Building Robotique",
    duration: "Half-day / Full-day",
    participants: "8-30 personnes",
    price: "Sur devis",
    description:
      "Offre legacy DigiRobot : vos équipes construisent et programment des robots ensemble, sur des défis créatifs qui mettent à l'épreuve communication, résolution de problèmes et esprit d'équipe.",
    image: IMAGES.about.workshop,
    benefits: [
      "Renforcer communication et collaboration",
      "Améliorer résolution de problèmes et décisions",
      "Encourager créativité et innovation",
      "Animation professionnelle ludique"
    ]
  },
  {
    id: 2,
    title: "Anniversaire DigiRobot",
    duration: "Atelier dédié",
    participants: "Groupe d'enfants",
    price: "Sur devis",
    description:
      "Offrez à votre enfant une expérience éducative et amusante : construction et programmation d'un robot, matériel fourni, animateur qualifié (page WP Anniversaire).",
    image: IMAGES.gallery.bulldozer,
    benefits: [
      "Atelier STEM ludique",
      "Matériel fourni",
      "Encadrement professionnel",
      "Souvenir concret pour chaque enfant"
    ]
  },
  {
    id: 3,
    title: "Formation Entreprise",
    duration: "1-5 jours",
    participants: "5-15 personnes",
    price: "Sur devis",
    description: "Formation sur mesure en robotique, programmation et nouvelles technologies pour vos équipes.",
    image: IMAGES.workshops.particulier,
    benefits: [
      "Programme personnalisé",
      "Certificat de formation",
      "Support pédagogique",
      "Formateurs experts"
    ]
  },
  {
    id: 4,
    title: "Partenariat Écoles",
    duration: "Année scolaire",
    participants: "Classe entière",
    price: "Sur devis",
    description: "Programme pédagogique complet pour intégrer la robotique dans votre établissement.",
    image: IMAGES.cursus.debutant,
    benefits: [
      "Matériel pédagogique fourni",
      "Formation des enseignants",
      "Suivi annuel",
      "Certification STEM"
    ]
  }
];

/** Fallback Contact si API centres indisponible — aligné sur centers.js / Booknetic. */
export const mockLocations = [
  {
    id: 1,
    name: "Nice Gambetta",
    address: "15 Boulevard Gambetta, 06000 Nice",
    phone: "06 98 85 49 48",
    email: "nice@digirobot.fr",
    hours: "Lun-Sam : 9h-18h (ateliers sur créneaux réservés)",
    image: IMAGES.centers["nice-gambetta"]
  },
  {
    id: 2,
    name: "Nice Jean-Médecin",
    address: "10 Avenue Georges Clemenceau, 06000 Nice",
    phone: "06 98 85 49 48",
    email: "jean-medecin@digirobot.fr",
    hours: "Lun-Sam : 9h-18h (ateliers sur créneaux réservés)",
    image: "/images/legacy/nice-jean-medecin-digirobot.jpg"
  },
  {
    id: 3,
    name: "Antibes",
    address: "25 Boulevard Albert 1er, 06600 Antibes",
    phone: "06 98 85 49 48",
    email: "antibes@digirobot.fr",
    hours: "Lun-Sam : 9h-18h (ateliers sur créneaux réservés)",
    image: "/images/legacy/antibes-digirobot.jpg"
  },
  {
    id: 4,
    name: "Pégomas",
    address: "1257 Av. de Grasse, 06580 Pégomas",
    phone: "06 98 85 49 48",
    email: "pegomas@digirobot.fr",
    hours: "Lun-Sam : 9h-18h (ateliers sur créneaux réservés)",
    image: IMAGES.centers.pegomas
  },
  {
    id: 5,
    name: "Cagnes-sur-Mer",
    address: "43 Chemin du Pain de Sucre, 06800 Cagnes-sur-Mer",
    phone: "06 98 85 49 48",
    email: "cagnes@digirobot.fr",
    hours: "Lun-Sam : 9h-18h (ateliers sur créneaux réservés)",
    image: IMAGES.centers["cagnes-sur-mer"]
  }
];

export const mockTestimonials = [
  {
    id: 1,
    name: "Sophie Martin",
    role: "Maman de Lucas, 9 ans",
    content: "Mon fils est passionné depuis qu'il a commencé le cursus. Il a développé une vraie logique de programmation et adore créer ses robots. Les formateurs sont excellents !",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?img=1"
  },
  {
    id: 2,
    name: "Thomas Dubois",
    role: "Papa de Emma, 12 ans",
    content: "Le stage vacances était fantastique. Emma a appris énormément en une semaine et veut continuer. Le rapport qualité-prix est excellent.",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?img=33"
  },
  {
    id: 3,
    name: "Marie Lefebvre",
    role: "Maman de Théo, 7 ans",
    content: "L'atelier découverte a été une révélation. Théo qui était timide s'est totalement épanoui. Il a même convaincu ses copains de s'inscrire !",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?img=5"
  },
  {
    id: 4,
    name: "Pierre Rousseau",
    role: "Directeur RH, TechCorp",
    content: "Nous avons organisé un team building robotique pour nos équipes. Une expérience unique qui a renforcé la cohésion. Très professionnel !",
    rating: 5,
    avatar: "https://i.pravatar.cc/150?img=12"
  }
];

export const mockBlogPosts = [
  {
    id: 1,
    title: "Pourquoi apprendre la robotique dès 6 ans ?",
    excerpt: "Découvrez les bénéfices de l'apprentissage précoce de la robotique et de la programmation pour le développement de votre enfant.",
    image: IMAGES.workshops.decouverte,
    category: "Éducation",
    author: "Julie Bernard"
  },
  {
    id: 2,
    title: "Les métiers du futur : préparer nos enfants",
    excerpt: "Intelligence artificielle, robotique, programmation... Comment les compétences STEM préparent les enfants aux métiers de demain.",
    image: IMAGES.stages.arduino,
    category: "Carrières",
    author: "Marc Durand"
  },
  {
    id: 3,
    title: "Retour sur notre stage d'hiver 2025",
    excerpt: "Une semaine incroyable avec nos jeunes roboticiens ! Découvrez les projets réalisés et les compétences acquises.",
    image: IMAGES.stages.hero,
    category: "Actualités",
    author: "Sophie Martin"
  }
];

export const mockElearningModules = [
  {
    id: 1,
    title: "Module 1 : Introduction à la Robotique",
    level: "Débutant",
    duration: "2 heures",
    lessons: 8,
    description: "Découvrez les bases de la robotique et construisez votre premier robot."
  },
  {
    id: 2,
    title: "Module 2 : Programmation Visuelle",
    level: "Débutant",
    duration: "3 heures",
    lessons: 12,
    description: "Apprenez à programmer avec Scratch et créez des animations."
  },
  {
    id: 3,
    title: "Module 3 : Capteurs et Actionneurs",
    level: "Intermédiaire",
    duration: "4 heures",
    lessons: 15,
    description: "Maîtrisez l'utilisation des capteurs pour créer des robots intelligents."
  },
  {
    id: 4,
    title: "Module 4 : Python pour la Robotique",
    level: "Avancé",
    duration: "6 heures",
    lessons: 20,
    description: "Programmez en Python et créez des robots autonomes."
  }
];

export const homeHowItWorksSteps = [
  {
    number: 1,
    icon: "Blocks",
    title: "Construire",
    description: "Les enfants assemblent et donnent vie à leurs robots.",
  },
  {
    number: 2,
    icon: "Monitor",
    title: "Coder",
    description: "Ils apprennent à programmer et à résoudre des défis.",
  },
  {
    number: 3,
    icon: "Brain",
    title: "Comprendre",
    description: "Ils développent leur logique, leur créativité et leur autonomie.",
  },
];

export const homeFeatures = [
  {
    icon: "ShieldCheck",
    title: "Encadrement certifié",
    description: "Formateurs passionnés, pédagogie éprouvée et environnement sécurisé pour chaque enfant.",
  },
  {
    icon: "Users",
    title: "Petits groupes",
    description: "8 à 10 élèves maximum par session pour un suivi attentif et une vraie progression.",
  },
  {
    icon: "Blocks",
    title: "Pédagogie ludique",
    description: "Makeblock, Artec, Scratch et Arduino — apprendre en construisant des robots concrets.",
  },
  {
    icon: "MapPin",
    title: "5 centres sur la Côte d'Azur",
    description: "Nice, Cannes, Monaco, Pégomas et Cagnes-sur-Mer — proche de chez vous.",
  },
  {
    icon: "Rocket",
    title: "Compétences du futur",
    description: "Logique, créativité et culture digitale — des atouts essentiels pour demain.",
  },
  {
    icon: "Wrench",
    title: "Matériel professionnel",
    description: "Kits robotiques, capteurs et outils de qualité — tout est fourni sur place.",
  },
];

export const homeAgeLevels = [
  {
    title: "6 – 8 ans",
    level: "Initiation",
    ageRange: "6-8 ans",
    description: "Premiers pas en robotique et programmation visuelle.",
    image: IMAGES.cursus.debutant,
    highlights: ["Construction de robots simples", "Programmation par blocs", "Projets créatifs"],
    link: "/cursus",
  },
  {
    title: "9 – 12 ans",
    level: "Perfectionnement",
    ageRange: "9-12 ans",
    description: "Capteurs, actionneurs et projets plus ambitieux.",
    image: IMAGES.cursus.intermediaire,
    highlights: ["Scratch avancé", "Capteurs et moteurs", "Projets collaboratifs"],
    link: "/cursus",
  },
  {
    title: "13 – 16 ans",
    level: "Expertise",
    ageRange: "13-16 ans",
    description: "Python, Arduino et robots autonomes.",
    image: IMAGES.cursus.avance,
    highlights: ["Programmation Python", "Microcontrôleurs", "Concours internationaux"],
    link: "/cursus",
  },
];

export const buildHomeStats = (centersCount = 5) => [
  { value: "500+", label: "Élèves formés", icon: "Users" },
  { value: String(centersCount), label: "Centres en PACA", icon: "MapPin" },
  { value: "50+", label: "Modules pédagogiques", icon: "Blocks" },
  { value: "4.9/5", label: "Satisfaction parents", icon: "Star" },
];

export const homeCoreValues = [
  { icon: "Lightbulb", title: "Ingéniosité", variant: "purple" },
  { icon: "Brain", title: "Pensée Critique", variant: "orange" },
  { icon: "Palette", title: "Créativité", variant: "purple" },
  { icon: "Monitor", title: "Culture Digitale", variant: "orange" },
];

export const mockFAQ = [
  {
    question: "À partir de quel âge peut-on commencer ?",
    answer: "Nos cursus et ateliers sont ouverts dès 6 ans, avec des programmes adaptés à chaque tranche d'âge (6-8, 9-12 et 13-16 ans)."
  },
  {
    question: "Quelle est la durée des sessions hebdomadaires ?",
    answer: "Les sessions hebdomadaires du cursus annuel durent entre 60 et 120 minutes, selon le niveau et le centre."
  },
  {
    question: "Proposez-vous des stages pendant les vacances ?",
    answer: "Oui, nous proposons des stages passionnants pendant les vacances, sur une durée de 10 à 12 heures (formules 10h ou 20h disponibles)."
  },
  {
    question: "Faut-il avoir des connaissances préalables ?",
    answer: "Non, aucune connaissance n'est requise. Nos programmes sont conçus pour accueillir les débutants complets et progresser à leur rythme."
  },
  {
    question: "Que se passe-t-il si mon enfant manque une séance ?",
    answer: "Nous proposons des séances de rattrapage et l'accès à la plateforme e-learning permet de suivre les cours manqués en vidéo."
  },
  {
    question: "Le matériel est-il fourni ?",
    answer: "Oui, tout le matériel est fourni en centre pendant les ateliers, les stages et le cursus. Les robots restent sur place."
  },
  {
    question: "Combien d'enfants par groupe ?",
    answer: "Nous limitons les groupes à 8-10 enfants maximum pour garantir un suivi personnalisé et une attention optimale de nos formateurs."
  },
  {
    question: "Puis-je visiter vos locaux avant de m'inscrire ?",
    answer: "Absolument ! Nous proposons des portes ouvertes régulières et vous pouvez prendre rendez-vous pour visiter nos centres à tout moment."
  }
];
